import React, { Component } from "react";
import { getNearbyPlaces, apiGetATFDestination, getDistanceMatrix } from "utils/API/TrxNowAPI";
import NewWebAppMapClass from "webapp/components/WebAppMap/WebAppMap";
import { TitleBar } from "webapp/components";
import NEWDestinationList from "webapp/components/DestinationList/DestinationList";
import DestinationList from "webapp/components/DestinationAutoComplete/DestinationAutoComplete";
//import { generateToken } from 'utils/here-maps/hereAuthSetup.js';
import { ReverseGeoCode } from "utils/here-maps/hereHttpRequest";
import logoIcon from "assets/logo/TrxNow_Logo_Alt_White_H.png";
import haversineDistance from "haversine-distance";
import { ChevronLeft } from "@mui/icons-material";
import { devLog } from "utils/devLog";
/**
 *
 * @param {
 * starting coords - import the disablement coords from
 *  the state to generate the local places
 * callBackFunc - imports the callback function which will update the main state
 *  with a new destination as necessary
 * t - translation object which allows the view to use i18n translation
 * } props
 * @returns
 */
export default class ConfirmDestination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disablementCoords: props.startingCoords,
      companyParams: props.companyParams,
      destList: null,
      Config_RGC: null,
      partner: props.company,
      providerRef: props.providerRef,
      t: props.t,
    };
  }

  //upon render of the component get the nearby places and generate the configReverseGeoCode
  componentDidMount() {
    //if partner is confirmed atf, use the atf partner api call to get their specific garage array selection
    if (this.state.partner === "ATF") {
      apiGetATFDestination(
        this.state.companyParams,
        this.state.providerRef,
        this.state.partner,
        this.state.disablementCoords,
        (results) => {
          this.setState({
            destList: [
              {
                business_status: "OPERATIONAL",
                distance: haversineDistance(this.state.disablementCoords, {
                  lat: results.DestLatitude,
                  lng: results.DestLongitutde,
                }),
                geometry: {
                  location: {
                    lat: results.DestLatitude,
                    lng: results.DestLongitude,
                  },

                  viewport: {
                    northeast: {
                      lat: results.DestLatitude,
                      lng: results.DestLongitude,
                    },
                    southwest: {
                      lat: results.DestLatitude,
                      lng: results.DestLongitude,
                    },
                  },
                },
                icon: null,
                icon_background_color: null,
                icon_mask_base_uri: null,
                name: results.DestCompanyName,
                place_id: results.DestCompanyID,
                reference: results.DestCompanyID,
                types: ["car_repair", "point_of_interest", "store", "establishment"],
                user_ratings: 18,
                vicinity: results.DestStreet + results.DestCity + results.DestState + results.DestZip,
              },
            ],
          });
        },
      );
    }

    //if any other partner is used, the standard get destination list is used.
    else {
      var tempArr = [];
      //devLog(this.state.disablementCoords)
      getNearbyPlaces(this.state.disablementCoords, (results) => {
        devLog(results.results);

        //filter array for companies that we don't want to present to the user
        const invalidNames = ["AJ Graphics", "NAPA", "AutoZone"];
        results.results.map((item) => {
          var foundBadCompany = false;
          invalidNames.map((item2) => {
            if (item.name.includes(item2)) {
              foundBadCompany = true;
            }
            return null;
          });
          if (!foundBadCompany && tempArr.length < 4) {
            tempArr.push(item);
          }
          return null;
        });
        this.setState({
          destList: tempArr,
        });
      });
    }

    // ! fix this
    // generateToken((result)=>{
    //     this.setState({
    //         Config_RGC: { headers: { Authorization: `Bearer ${result.access_token}`} }
    //     })
    // })
  }

  //callback function used in  that stores the map information
  mapCreated = (data) => {
    this.setState({
      H: data.H,
      hMap: data.map,
    });
  };

  //wrapper callback function that calls reversegeocode function from hereHttpRequest.js, which accepts coordss, authToken, and a callbackfunction
  tempPrint = (data) => {
    ReverseGeoCode({ lat: data.lat, lng: data.lng }, this.state.Config_RGC, (data) => {
      this.props.callBackFunc(data);
    });
  };
  render() {
    //const { t } = this.props;
    const LocateUserObj = {
      img: logoIcon,
      partner: this.state.partner,
      fragment: (
        <React.Fragment>
          <p className="mb-0">
            <strong>{this.state.t("description.ConfirmDestinationTitleBar1")}</strong>
          </p>
        </React.Fragment>
      ),
    };
    return (
      <React.Fragment>
        <div
          style={{
            background: "black",
            color: "white",
            width: "100%",
            textAlign: "left",
          }}
        >
          <button
            type="button"
            style={{
              background: "black",
              color: "white",
              border: "none",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
            onClick={() => {
              if (this.props.backButtonFunc) {
                this.props.backButtonFunc();
              }
            }}
          >
            <ChevronLeft style={{ color: "white", height: 32 }} /> <div>Back</div>
          </button>
        </div>
        {this.state.destList && this.state.destList?.length && (
          <NewWebAppMapClass
            zoomLevel={11}
            height={"300px"}
            destList={this.state.destList}
            mapCreated={this.mapCreated}
            disablementCoords={this.state.disablementCoords}
            callBackFunc={this.tempPrint}
          />
        )}
        <TitleBar data={LocateUserObj} />
        <DestinationList submitFunc={this.tempPrint} />
        {this.state.destList && (
          <NEWDestinationList
            submitFunc={this.tempPrint}
            disablementCoords={this.state.disablementCoords}
            destList={this.state.destList}
          />
        )}{" "}
        {/** add this in conditional for local testing => { && this.state.destList.length === [] }*/}
      </React.Fragment>
    );
  }
}
